<script setup>
/**
 * StartGuideTourModal — Pre-tour welcome modal.
 *
 * Shown before the interactive tour begins. Gives the user context about
 * what the tour covers and offers two choices:
 *   - "Sluiten"   → skip the tour entirely (marks it as completed)
 *   - "Tour starten" → start the 8-step interactive tour
 *
 * Props:
 *   show — controls visibility
 *
 * Emits:
 *   start  — user wants to begin the tour
 *   close  — user wants to skip (also marks tour as completed)
 */
defineProps({
    show: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['start', 'close'])
</script>

<template>
    <div v-if="show" class="modal-backdrop guide-tour-backdrop">
        <div class="modal-container">
            <div class="modal-content modal-sm guide-tour-start-modal">
                <div class="modal-header guide-tour-start-header">
                    <h2 class="modal-title">Rondleiding WIZZR 14.0</h2>
                </div>
                <div class="modal-body">
                    <p>
                        We zijn verheugd om aan te kondigen dat WIZZR 14.0 is gelanceerd
                        en nodigen je uit om de geheel vernieuwde applicatie te ontdekken.
                    </p>
                    <p>
                        Klik op 'Tour starten' om de rondleiding te beginnen. Als je wilt,
                        kun je de rondleiding op een ander moment hervatten door op de knop
                        'Tour starten' te klikken, in het menu bij je profielnaam.
                    </p>
                </div>
                <div class="modal-footer guide-tour-start-footer">
                    <button class="btn btn-secondary" @click="emit('close')">
                        Sluiten
                    </button>
                    <button class="btn btn-primary" @click="emit('start')">
                        Tour starten
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
